// the Vendor Portal has an idiosyncratic error system. For some reason, errors are reported as strings.
export const findError = (...errorMessages: (string | undefined)[]): string | undefined => {
  return errorMessages.find((message) => message !== undefined);
};
